import React, { useEffect, useState } from "react";
import { deleteMessage } from "../services/messageService"; // Import delete function
import "../styles/list.css";
import { FamilyResponse } from "../types/FamilyTypes";
import { MessageResponse } from "../types/MessageTypes";
import { useNavigate } from "react-router-dom";

interface MessageTableProps {
  messages: MessageResponse[];
  families: FamilyResponse[];
  loadMessages: () => void;
}

const MessageTable: React.FC<MessageTableProps> = ({ messages, families, loadMessages }) => {
  const navigate = useNavigate();

  // Function to handle delete
  const handleDelete = async (id: number) => {
    if (window.confirm("Are you sure you want to delete this message?")) {
      await deleteMessage(id);
      loadMessages(); // Refresh message list
    }
  };

  const convertUtcToLocal = (utcDateString: string) => {
    return new Date(utcDateString + "z").toLocaleString();
  };

  const convertFrequencyText = (frequency: string, cycle: number) => {
    var finalFrequency = "";

    if (frequency === "Hourly") {
      finalFrequency = "Hour";
    }
    else if (frequency === "Daily") {
      finalFrequency = "Day";
    }
    else if (frequency === "Weekly") {
      finalFrequency = "Week";
    }
    else if (frequency === "Monthly") {
      finalFrequency = "Month";
    }
    else if (frequency === "Yearly") {
      finalFrequency = "Year";
    }
    else if (frequency === "Custom") {
      finalFrequency = "Minute";
    }

    if (cycle > 1)
    {
      finalFrequency += "s";
    }

    return finalFrequency;
  }

  return (
    <div className="overflow-x-auto message-table">
      <table>
        <thead>
          <tr>
            <th>Sender</th>
            <th>Sent Body</th>
            <th>Family</th>
            <th>Status</th>
            <th>Created Date</th>
            <th>Scheduled Plans</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {messages.map((msg) => (
            <tr key={msg.id} className="hover:bg-gray-100">
              <td>{msg.sender}</td>
              <td>{msg.sentBody}</td>
              <td>{families.find((f) => f.id === msg.familyId)?.familyName || "Unknown Family"}</td>
              <td>{msg.status}</td>
              <td>{convertUtcToLocal(msg.createdDate)}</td>
              <td className="schedules">
                {msg.scheduledPlans.length > 0 ? (
                  <div className="pl-4">
                    {msg.scheduledPlans.map((plan) => (
                      <div key={plan.id}>
                        <p>From: {convertUtcToLocal(plan.scheduledStartTime)} ~ To: {convertUtcToLocal(plan.scheduledEndTime)}</p>
                        <p>Frequency: {plan.scheduleCycle} {convertFrequencyText(plan.frequency, plan.scheduleCycle)}</p>
                        <p>Is Recurred?: {plan.isRecurred ? "Yes" : "No"}</p>
                        {/* <p>Token: {plan.scheduledPlanToken}</p> */}
                      </div>
                    ))}
                  </div>
                ) : (
                  "No Scheduled Plans"
                )}
              </td>
              <td>
                <div className="button-group">
                  <button
                    className="update-btn"
                    onClick={() => navigate(`/messages/${msg.id}`)}
                  >
                    Detail
                  </button>
                  <button
                    className="delete-btn"
                    onClick={() => handleDelete(msg.id)}
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MessageTable;
